import { get, post } from "../axiosClient"

type GetAdminAlertProps = {
    token: string
}

type GetAdminAlertResponse = {
    alert?: string,
    errorMessage?: string
}

export const getAdminAlert = async ({ token }: GetAdminAlertProps): Promise<GetAdminAlertResponse> => {
    return await get({
        params: {},
        path: 'admin/websystem/alert',
        token: token
    }).then((res) => {
        if (res.status === 200) {
            return { alert: res.data }
        } else {
            return { errorMessage: res.data }
        }
    });
}

type PostAdminAlertProps = {
    token: string,
    alert: string
}

type PostAdminAlertResponse = {
    errorMessage?: string
}

export const postAdminAlert = async ({ token, alert }: PostAdminAlertProps): Promise<PostAdminAlertResponse> => {
    return await post({
        params: {},
        path: 'admin/websystem/alert',
        token: token,
        data: {alert}
    }).then((res) => {
        if (res.status === 200) {
            return { }
        } else {
            return { errorMessage: "Nepovedlo se uložit upozornění do websystému :(" }
        }
    });
}